import { render, staticRenderFns } from "./ShippingBaseTab.vue?vue&type=template&id=6e705aa5&"
import script from "./ShippingBaseTab.vue?vue&type=script&lang=js&"
export * from "./ShippingBaseTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports